import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as echarts from 'echarts';
export default {
  props: {
    vData: {
      type: Object,
      default: function _default() {
        return {
          data: [],
          title: ''
        };
      }
    }
  },
  watch: {
    'vData.data': {
      handler: function handler() {
        var _this = this;
        this.$nextTick(function () {
          _this.initChart();
        });
      },
      deep: true
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {
    initChart: function initChart() {
      // 实例化对象
      var myChart = echarts.init(document.getElementById('chart_id2'));
      var charts = {
        // 按顺序排列从大到小
        nameList: [],
        dataList: []
      };
      if (this.vData.data) {
        this.vData.data.map(function (item) {
          charts.nameList.push(item.spu_name);
          charts.dataList.push(item.ct);
        });
      }
      var top10nameList = charts.nameList;
      var top10dataList = charts.dataList;
      var lineY = [];
      for (var i = 0; i < charts.nameList.length; i++) {
        var data = {
          name: charts.nameList[i],
          color: 'rgb(243,186,130)',
          value: top10dataList[i],
          itemStyle: {
            normal: {
              show: true,
              barBorderRadius: 10
            },
            emphasis: {
              shadowBlur: 15,
              shadowColor: 'rgba(0, 0, 0, 0.1)'
            }
          }
        };
        lineY.push(data);
      }

      // 指定配置和数据
      var option = {
        color: 'rgb(243,186,130)',
        tooltip: {
          trigger: 'item'
        },
        grid: {
          borderWidth: 0,
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        }],
        yAxis: [{
          type: 'category',
          inverse: true,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            inside: false,
            textStyle: {
              color: '#b3ccf8',
              fontSize: 13
            },
            formatter: function formatter(value) {
              var texts = value;
              if (texts.length > 15) {
                // 具体多少字就看自己了
                texts = texts.substr(0, 15) + '...';
              }
              return texts;
            }
          },
          data: top10nameList
        }, {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            inside: false,
            textStyle: {
              color: '#b3ccf8',
              fontSize: 13
            },
            formatter: function formatter(val) {
              return "".concat(val);
            }
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: false
          },
          data: top10dataList.reverse()
        }],
        series: [{
          name: '',
          type: 'bar',
          zlevel: 2,
          barWidth: '13px',
          data: lineY,
          animationDuration: 1500,
          label: {
            normal: {
              color: '#b3ccf8',
              show: false,
              position: [0, '-15px'],
              textStyle: {
                fontSize: 13
              },
              formatter: function formatter(a, b) {
                return a.name;
              }
            }
          }
        }]
      };

      // 把配置给实例对象
      myChart.setOption(option, true);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {}
};